<template>
  <div :class="{ hide: hidden }">
    <el-pagination ref="f-el-pagination" background :current-page.sync="currentPage" :page-size.sync="pageSize" :pager-count="5" :layout="layout" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
  </div>
</template>

<script>
import store from '@/store/store'
export default {
  name: 'FPagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    pindex: {
      type: Number,
      default: 1
    },
    psize: {
      type: Number,
      default: 10
    },
    sizesShow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    hidden () {
      return !(this.total > 0)
    },
    layout () {
      if (this.total <= this.psize) {
        return this.sizesShow ? '->, total, sizes' : '->, total'
      } else {
        return this.sizesShow ? '->, total, sizes, prev, pager, next' : '->, total, prev, pager, next'
      }
    },
    currentPage: {
      get () {
        return this.pindex
      },
      set (val) {
        this.$emit('update:pindex', val)
      }
    },
    pageSize: {
      get () {
        return this.psize
      },
      set (val) {
        this.$emit('update:psize', val)
      }
    }
  },
  mounted () {
    /* ------------------ Bug Fix ------------------ */
    // 修复当前页存在初始值时，pindex获得初始值，但internalCurrentPage仍为1
    // this.$refs['f-el-pagination'].internalCurrentPage = this.pindex
  },
  methods: {

    handleSizeChange (val) {
      store.commit('SET_PSIZE', val)
      this.$emit('change', 1)
    },

    handleCurrentChange (val) {
      store.commit('SET_PINDEX_CHANGE', true)
      this.$emit('change', val)
    }
  }
}
</script>
